window.addEventListener("load", function () {
  setTimeout(() => {
    document.querySelectorAll('.jdgm-link').forEach(el => {
      let text = el.textContent.trim();
      el.textContent = text.substring(0, 3);
    });
  }, 1000); // delay important hai
});